import { useQuery as useReactQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { toast } from "Layout/slice";
import { parseErrorMessage } from "utils";

export const useQuery = ({
  key = "data",
  queryKey = ["data"],
  queryFn = () => {},
  onError,
  onSuccess,
  enabled = true,
  staleTime = 5 * 60 * 1000, // 5 minutes
  cacheTime = 10 * 60 * 1000, // 10 minutes
  placeholderData,
}) => {
  const dispatch = useDispatch();

  const handleError = useCallback(
    (error) => {
      dispatch(
        toast({
          type: "error",
          body: parseErrorMessage(error),
        })
      );

      if (onError) onError(error);
    },
    [dispatch, onError]
  );

  const {
    isLoading,
    isFetching,
    isSuccess,
    isStale,
    data,
    refetch,
    isError,
    error,
  } = useReactQuery({
    queryKey: queryKey ? queryKey : [key],
    queryFn,
    throwOnError: false,
    onError: handleError,
    onSuccess,
    enabled,
    staleTime,
    cacheTime,
    placeholderData,
  });

  return {
    isLoading,
    isFetching,
    isSuccess,
    isStale,
    data,
    refetch,
    isError,
    error,
  };
};
